export default class BlockMenu {
    constructor(container, options) {
        const defaultOptions = {
            tabs: '.tabs-container .tab',
            menuSections: '.block-menu-section',
            externalPdfs: '.external-pdf',
            descriptions: '.description-container',
        };
        this.options = Object.assign({}, defaultOptions, options);

        this.container = document.querySelector(container);
        this.tabs = this.container.querySelectorAll(this.options.tabs);
        this.externalPdfs = this.container.querySelectorAll(this.options.externalPdfs);
        this.descriptions = this.container.querySelectorAll(this.options.descriptions);
        this.menuSections = this.container.querySelectorAll(this.options.menuSections);

        this.setEvents();
        this.onLoad();
    }

    setEvents() {
        var self = this;
        this.tabs.forEach(tab => {
           tab.addEventListener('click', function() { self.clickTab(this); }); 
        });
    }
    
    onLoad() {
        var params = (new URL(document.location)).searchParams
        var id = params.get("show");

        if (id !== null) {
            this.filterFoodMenu(id);
        } else if (this.tabs.length > 0) {
            this.showFirstTab();
        }

        this.menuSections.forEach(section => {
            section.addEventListener('click', () => {
                if (section.classList.contains('show-accordion')) {
                    section.classList.remove('show-accordion')                    
                } else {
                    section.classList.add('show-accordion')
                }
            })
        })
    }
    
    showFirstTab() {
        this.clickTab(this.tabs[0]);
    }
    
    clickTab(elem) {
        var id = elem.dataset.id;
        
        this.filterFoodMenu(id);
    }
    
    filterFoodMenu(id) {
        console.log(id);
        this.tabs.forEach(tab => {
            if (tab.classList.contains('show')) {
                tab.classList.remove('show')
            } else {
                tab.classList.add('show')
            }

            if (tab.classList.contains(id)) {
                tab.classList.add('active')
            } else {
                tab.classList.remove('active')
            }
        })

        this.externalPdfs.forEach(container => {
            if (container.classList.contains(id)) {
                container.classList.add('show')
            } else {
                container.classList.remove('show')
            }
        })

        this.descriptions.forEach(container => {
            if (container.classList.contains(id)) {
                container.classList.add('show')
            } else {
                container.classList.remove('show')
            }
        })

        this.menuSections.forEach(section => {
            if (section.classList.contains(id)) {
                section.classList.add('show')
            } else {
                section.classList.remove('show')
            }
        })
    }
}